import { language } from 'settings';
import intl from 'react-intl-universal';

const config = {
  defaultLanguage: language,
  options: [
    {
      languageId: 'english',
      locale: 'en',
      text: 'English',
    },
    {
      languageId: 'persian',
      locale: 'fa',
      text: 'Persian',
    },
  ],
};

export function getCurrentLanguage(lang) {
  let selecetedLanguage = config.options[0];
  config.options.forEach(language => {
    if (language.languageId === lang) {
      selecetedLanguage = language;
    }
  });
  return selecetedLanguage;
}

export function universalinit (locale,AppLocale){
  let universalLocals = {};
  const keys = Object.keys(AppLocale);
  keys.forEach( x=>
    universalLocals[x] = AppLocale[x].messages
  )
  intl.init({
    currentLocale: locale,
    locales : universalLocals
  });
}


export default config;
